import React from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { ComponentJointPool } from "component/ConfigJointPool";
import { ComponentDisallowEmail } from "component/ConfigDisallowEmail";
import { ComponentDisallowMsg } from "component/ConfigAllowMessaging";
import "./index.scss";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { PageCredential } from "component/PageCredential";

const PageProfileConfig = connect(stateMap)(props => {
    return (
        <div className="page-profile-config container">
            <PageCredential title="Configuration"/>
            <div className="w-640 mx-auto">
                <BlockHeader title="Your Configuration"/>
            </div>

            <div className="config-fields">
                <div className="field-label">
                    Disable email for notification
                    <span className="text-xs mt-sm font-light block">This button controls whether notifications in crowdbees will be sent to your email</span>
                </div>
                <div className="field-value">
                    <ComponentDisallowEmail/>
                </div>
            </div>
            <div className="config-fields">
                <div className="field-label">
                    Disable Messaging
                    <span className="text-xs mt-sm font-light block">This button allows your account to receive messages sent by other users</span>
                </div>
                <div className="field-value">
                    <ComponentDisallowMsg/>
                </div>
            </div>
        </div>
    )
})

export default PageProfileConfig;